import { render, staticRenderFns } from "./SystemPublisherConfigurationTool.vue?vue&type=template&id=19c9a8a4&scoped=true"
import script from "./SystemPublisherConfigurationTool.vue?vue&type=script&lang=js"
export * from "./SystemPublisherConfigurationTool.vue?vue&type=script&lang=js"
import style0 from "./SystemPublisherConfigurationTool.vue?vue&type=style&index=0&id=19c9a8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9a8a4",
  null
  
)

export default component.exports